module.exports = "/images/arrow-right-blue.png?3e1b7e1ebb526a0d76b2f755f756b12a";